var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"cateogry _min-h-screen"},[_c('category-body',{attrs:{"uid":_vm.$route.params.category}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }